import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button } from '../../components/ui.tsx';

/**
 * Recorte que veio de um cartão da Visão geral (`?indicator=`, ADR 0097). Limpar tira só o recorte
 * do endereço: a aba continua a mesma.
 */
export function useCardFilter<T extends string>(values: readonly T[]) {
  const [filter, setFilter] = useState<T | null>(() => {
    const value = new URLSearchParams(window.location.search).get('indicator');
    return values.find((v) => v === value) ?? null;
  });
  const clear = () => {
    setFilter(null);
    const url = new URL(window.location.href);
    url.searchParams.delete('indicator');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}`);
  };
  return [filter, clear] as const;
}

export function CardFilterNotice({ label, onClear }: { label: string; onClear: () => void }) {
  const { t } = useTranslation();
  return (
    <p role="status" className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-muted">{t('homeCards.listFilter')}</span>
      <Badge tone="info">{label}</Badge>
      <Button variant="secondary" onClick={onClear}>
        {t('homeCards.clearFilter')}
      </Button>
    </p>
  );
}
